import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight,faArrowDown } from "@fortawesome/free-solid-svg-icons";
import {
  faImages,
  faCopy,
  faUpRightFromSquare,
  faSearch,
  faTimes,
  faSyncAlt
} from "@fortawesome/free-solid-svg-icons";
import html2canvas from "html2canvas";
import "./NotamGrid.css";
import axios from "axios";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { isAfter, isBefore, parseISO } from "date-fns";
import TextField from "@mui/material/TextField";

function NotamGrid() {
  const [twitterPosts, setTwitterPosts] = useState([]);
  const [facebookPosts, setFacebookPosts] = useState([]);
  const [filteredTwitterPosts, setFilteredTwitterPosts] = useState([]);
  const [filteredFacebookPosts, setFilteredFacebookPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [twitterSearchTerm, setTwitterSearchTerm] = useState("");
  const [facebookSearchTerm, setFacebookSearchTerm] = useState("");
  const [twitterStartDate, setTwitterStartDate] = useState(null);
  const [twitterEndDate, setTwitterEndDate] = useState(null);
  const [facebookStartDate, setFacebookStartDate] = useState(null);
  const [facebookEndDate, setFacebookEndDate] = useState(null);
  const [isapiLoading, setIsapiLoading] = useState(false);
  const [isapifLoading, setIsfapiLoading] = useState(false);
  const [isRightSectionCollapsed, setIsRightSectionCollapsed] = useState(true)
  const [isNotamModalOpen, setIsNotamModalOpen] = useState(false);
  const [selectedNotamImage, setSelectedNotamImage] = useState(null);
  const [isFetchingAllNotams, setIsFetchingAllNotams] = useState(false);

  const handleShowMore = () => {
    setIsFetchingAllNotams((prevState) => !prevState); // Toggle the state
  
    if (isFetchingAllNotams) {
      // If we are fetching all Notams, show all posts
      setFilteredTwitterPosts(twitterPosts); // Set all Twitter posts
    } else {
      // If we are fetching Indian accounts' data (MrCool and detresfa_)
      const indianNotams = twitterPosts.filter(
        (post) => post.author_username === "Mrcool63040811" || post.author_username === "detresfa_"
      );
      setFilteredTwitterPosts(indianNotams); // Set only Indian accounts' posts
    }
  };
  
  useEffect(() => {
    handleShowMore(); // Fetch Indian accounts' data when the component is first loaded
  }, []);
  
  
  
  

  useEffect(() => {
    // Fetch initial data and set state
    fetch("api/notam-posts/")
      .then((response) => response.json())
      .then((data) => {
        const twitterData = data.find(
          (platform) => platform.platform === "Twitter"
        );
        const twitterPosts = twitterData ? twitterData.posts : [];
        setTwitterPosts(twitterPosts);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching posts:", error);
        setIsLoading(false);
      });
  }, []);

  useEffect(() => {
    fetch("api/notam-posts/")
      .then((response) => response.json())
      .then((data) => {
        const twitterData = data.find(
          (platform) => platform.platform === "Twitter"
        );
        const facebookData = data.find(
          (platform) => platform.platform === "Facebook"
        );

        const twitterPosts = twitterData ? twitterData.posts : [];
        const facebookPosts = facebookData ? facebookData.posts : [];

        setTwitterPosts(twitterPosts);
        setFacebookPosts(facebookPosts);
        setFilteredTwitterPosts(twitterPosts);
        setFilteredFacebookPosts(facebookPosts);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching posts:", error);
        setIsLoading(false);
      });
  }, []);

  const handleNotamImageClick = (imageUrl) => {
    setSelectedNotamImage(imageUrl); // Set the clicked image URL
    setIsNotamModalOpen(true); // Open the modal
  };

  const NotamModal = ({ isOpen, imageUrl, onClose }) => {
    if (!isOpen || !imageUrl) return null;

    return (
      <div
        className="notam-modal-overlay"
        onClick={onClose}
      >
        <div className="notam-modal-content" onClick={(e) => e.stopPropagation()}>
          <img src={imageUrl} alt="Full Size" className="notam-modal-image" />
          <button className="notam-close-btn" onClick={onClose}>X</button>
        </div>
      </div>
    );
  };


  const toggleRightSection = () => {
    setIsRightSectionCollapsed((prev) => !prev);
  };

  const handleTwitterSearch = (e) => {
    const keyword = e.target.value.toLowerCase();
    setTwitterSearchTerm(keyword); // Set search term to state

    setFilteredTwitterPosts(
      twitterPosts.filter(
        (post) =>
          post.text.toLowerCase().includes(keyword) ||
          post.title?.toLowerCase().includes(keyword)
      )
    );
  };


  const handleFacebookSearch = (e) => {
    const keyword = e.target.value.toLowerCase(); // Get the search term in lowercase
    setFacebookSearchTerm(keyword);

    setFilteredFacebookPosts(
      facebookPosts.filter((post) => {
        // Use conditional checks to prevent errors
        const postText = post.text ? post.text.toLowerCase() : "";  // Default to empty string if null/undefined
        const postTitle = post.title ? post.title.toLowerCase() : ""; // Same for title

        // Filter the posts based on the search term
        return postText.includes(keyword) || postTitle.includes(keyword);
      })
    );
  };


  const clearTwitterSearch = () => {
    setTwitterSearchTerm("");
    setFilteredTwitterPosts(twitterPosts);
  };

  const clearFacebookSearch = () => {
    setFacebookSearchTerm("");
    setFilteredFacebookPosts(facebookPosts);
  };

  const [expandedPosts, setExpandedPosts] = useState({});







  const copyScreenshotToClipboard = async (postId) => {
    try {
      const element = document.querySelector(`#post-${postId}`);
      if (!element) {
        alert("Post not found!");
        return;
      }

      const canvas = await html2canvas(element, { useCORS: true });
      const blob = await new Promise((resolve) =>
        canvas.toBlob(resolve, "image/png")
      );

      const clipboardItem = new ClipboardItem({ "image/png": blob });
      await navigator.clipboard.write([clipboardItem]);

      alert("Screenshot copied to clipboard!");
    } catch (error) {
      console.error("Failed to copy screenshot:", error);
      alert("Failed to copy screenshot. Please try again.");
    }
  };

  const copyTextToClipboard = (text) => {
    try {
      navigator.clipboard.writeText(text);
      alert("Text copied to clipboard!");
    } catch (error) {
      console.error("Failed to copy text:", error);
      alert("Failed to copy text.");
    }
  };
  const openXPostLink = (postId, authorUsername) => {
    if (!postId || !authorUsername) {
      console.error("Invalid post ID or author username.");
      return;
    }

    // Construct the URL
    const url = `https://x.com/${authorUsername}/status/${postId}`;

    // Open the URL in a new tab
    window.open(url, "_blank");
  };
  // facebook openlink notam function

  const openFBPostLink = (postId) => {
    if (!postId) {
      console.error("Invalid post ID");
      return;
    }

    // Construct the URL
    const url = `https://facebook.com/${postId}`;

    // Open the URL in a new tab
    window.open(url, "_blank");
  };

  const filterTwitterPostsByDate = () => {
    if (!twitterStartDate && !twitterEndDate) {
      setFilteredTwitterPosts(twitterPosts); // Reset if no date filters are selected
      return;
    }

    const filtered = twitterPosts.filter((post) => {
      const postDate = parseISO(post.created_time); // Convert timestamp to Date object

      const isAfterStart = twitterStartDate
        ? isAfter(postDate, twitterStartDate)
        : true;
      const isBeforeEnd = twitterEndDate
        ? isBefore(postDate, twitterEndDate)
        : true;

      return isAfterStart && isBeforeEnd;
    });

    setFilteredTwitterPosts(filtered);
  };

  const filterFacebookPostsByDate = () => {
    if (!facebookStartDate && !facebookEndDate) {
      setFilteredFacebookPosts(facebookPosts);
      return;
    }

    const filtered = facebookPosts.filter((post) => {
      const postDate = parseISO(post.created_time);

      const isAfterStart = facebookStartDate
        ? isAfter(postDate, facebookStartDate)
        : true;
      const isBeforeEnd = facebookEndDate
        ? isBefore(postDate, facebookEndDate)
        : true;

      return isAfterStart && isBeforeEnd;
    });

    setFilteredFacebookPosts(filtered);
  };
  const handletwiterSubmit = async (...apiEndpoints) => {
    setIsapiLoading(true);
    try {

      // Loop through the endpoints and send a POST request to each one
      for (const apiEndpoint of apiEndpoints) {
        const response = await axios.post(apiEndpoint);

        // Handle successful response for each endpoint
        console.log(`Response from ${apiEndpoint}:`, response.data);
      }

      alert("Data submitted successfully!");
      setIsapiLoading(false);
      window.location.reload(); // Reload the page after submission
    } catch (error) {
      // Handle errors
      console.error(
        "Error submitting data:",
        error.response ? error.response.data : error.message
      );
      alert("Failed to submit data. Please try again.");
      setIsapiLoading(false);
    }
  };


  const handlefbSubmit = async (...apiEndpoints) => {
    setIsfapiLoading(true);
    try {

      // Loop through the endpoints and send a POST request to each one
      for (const apiEndpoint of apiEndpoints) {
        const response = await axios.post(apiEndpoint);

        // Handle successful response for each endpoint
        console.log(`Response from ${apiEndpoint}:`, response.data);
      }

      alert("Data submitted successfully!");
      setIsfapiLoading(false);
      window.location.reload(); // Reload the page after submission
    } catch (error) {
      // Handle errors
      console.error(
        "Error submitting data:",
        error.response ? error.response.data : error.message
      );
      alert("Failed to submit data. Please try again.");
      setIsfapiLoading(false);
    }
  };

  const openUserProfile = (platform, userId) => {
    if (!userId) {
      console.error("Invalid user ID");
      return;
    }

    let url = "";
    if (platform === "facebook") {
      url = `https://www.facebook.com/${userId}`;
    } else if (platform === "twitter") {
      url = `https://www.x.com/${userId}`;
    }

    window.open(url, "_blank");
  };

  const highlightText = (text, searchTerm) => {
    if (!searchTerm || !text) return text; // If no search term or text, return as is

    const regex = new RegExp(`(${searchTerm})`, "gi"); // Case insensitive match
    const highlightedText = text.replace(regex, (match) => {
      return `<span class="highlight">${match}</span>`; // Wrap matches in span for highlighting
    });

    return highlightedText; // Return the text with highlighted parts
  };



  // Function to render the description for posts
  const renderDescription = (text, id, platform) => {
    if (!text) {
      return <div>No description available</div>;
    }

    const isExpanded = expandedPosts[id]; // Check if the post is expanded
    const MAX_CHARACTERS = 160; // Limit to 160 characters
    const lines = text.split("\n");

    // If the post is expanded, show the full text; otherwise, truncate it
    if (platform === "twitter") {
      return renderTwitterDescription(text, id, isExpanded, lines, MAX_CHARACTERS);
    } else if (platform === "facebook") {
      return renderFacebookDescription(text, id, isExpanded, lines, MAX_CHARACTERS);
    }
  };

  // Logic for rendering Twitter description (Left side)
  const renderTwitterDescription = (text, id, isExpanded, lines, MAX_CHARACTERS) => {
    if (isExpanded || text.length <= MAX_CHARACTERS) {
      return (
        <>
          <div
            dangerouslySetInnerHTML={{
              __html: highlightText(text, twitterSearchTerm), // Apply highlighting for Twitter
            }}
          />
          {text.length > MAX_CHARACTERS && (
            <button className="read-more-btn" onClick={() => toggleReadMore(id)}>
              Read Less
            </button>
          )}
        </>
      );
    }

    return (
      <>
        <div
          dangerouslySetInnerHTML={{
            __html: highlightText(text.slice(0, MAX_CHARACTERS) + '...', twitterSearchTerm), // Show truncated text
          }}
        />
        <button className="read-more-btn" onClick={() => toggleReadMore(id)}>
          Read More
        </button>
      </>
    );
  };

  // Logic for rendering Facebook description (Right side)
  const renderFacebookDescription = (text, id, isExpanded, lines, MAX_CHARACTERS) => {
    if (isExpanded || text.length <= MAX_CHARACTERS) {
      return (
        <>
          <div
            dangerouslySetInnerHTML={{
              __html: highlightText(text, facebookSearchTerm), // Apply highlighting for Facebook
            }}
          />
          {text.length > MAX_CHARACTERS && (
            <button className="read-more-btn" onClick={() => toggleReadMore(id)}>
              Read Less
            </button>
          )}
        </>
      );
    }

    return (
      <>
        <div
          dangerouslySetInnerHTML={{
            __html: highlightText(text.slice(0, MAX_CHARACTERS) + '...', facebookSearchTerm), // Show truncated text
          }}
        />
        <button className="read-more-btn" onClick={() => toggleReadMore(id)}>
          Read More
        </button>
      </>
    );
  };


 

  // Toggle function to update the expandedPosts state
  const toggleReadMore = (id) => {
    setExpandedPosts((prevState) => ({
      ...prevState,
      [id]: !prevState[id], // Toggle the post expansion state
    }));
  };








  return (
    <div className="notam_content">
      <div className="main-container">
        {/* Twitter Posts Section */}
        <div className={`left-section-main ${isRightSectionCollapsed ? "expanded" : ""}`}>
          <h2 className="twitter-fixed-header">
            <img
              src={`${process.env.PUBLIC_URL}/icons/twitter.png`}
              alt="Twitter Icon"
              className="twitter-icon"
            />
            Twitter NOTAM's
          </h2>

          <div className="twitter-post-header-search">
  {/* Search Input */}
  <input
    type="text"
    placeholder="Search Twitter NOTAM's"
    className="search-bar"
    value={twitterSearchTerm}
    onChange={handleTwitterSearch}
  />
  {twitterSearchTerm && (
    <button className="clear-button" onClick={clearTwitterSearch}>
      <FontAwesomeIcon icon={faTimes} />
    </button>
  )}

  {/* Date Filters (Placed before Search Button) */}
  <div className="date-filters">
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <div style={{ display: "flex", alignItems: "center" }}>
        <span style={{ marginRight: "10px", fontWeight: "bold" }}>
          From
        </span>
        <DatePicker
          value={twitterStartDate}
          onChange={(newValue) => {
            setTwitterStartDate(newValue);
            filterTwitterPostsByDate(); // ✅ Call function when user selects date
          }}
          renderInput={(params) => <TextField {...params} size="small" />}
        />
      </div>

      <div style={{ display: "flex", alignItems: "center" }}>
        <span style={{ marginRight: "10px", fontWeight: "bold" }}>TO</span>
        <DatePicker
          value={twitterEndDate}
          onChange={(newValue) => {
            setTwitterEndDate(newValue);
            filterTwitterPostsByDate(); // ✅ Call function when user selects date
          }}
          renderInput={(params) => <TextField {...params} size="small" />}
        />
      </div>

      <button className="search-button">
        <FontAwesomeIcon icon={faSearch} />
      </button>

      <button
        onClick={() =>
          handletwiterSubmit("api/t-notam/")
        }
        style={{
          background: isapiLoading ? "#ccc" : "#007BFF", // Change button color while loading
          color: "#fff", // Text color
          border: "none",
          borderRadius: "5px",
          padding: "6px 12px",
          cursor: isapiLoading ? "not-allowed" : "pointer", // Disable button when loading
          display: "flex", // To align the icon properly
          alignItems: "center", // Vertically center the icon
          justifyContent: "center", // Horizontally center the icon
        }}
        disabled={isapiLoading} // Disable button while loading
      >
        {isapiLoading ? (
          <div className="loader-small" style={{ borderTopColor: "#fff" }} /> // Loader
        ) : (
          <FontAwesomeIcon icon={faSyncAlt} style={{ fontSize: "16px" }} /> // Refresh icon
        )}
      </button>

      {/* Show More Button */}
      <button
  onClick={handleShowMore}
  style={{
    background: "#129278", // Green color for the "Show More" button
    color: "#fff", // Text color
    border: "none",
    borderRadius: "5px",
    padding: "6px 12px",
    cursor: "pointer",
    display: "flex", // To align the icon properly
    alignItems: "center", // Vertically center the icon
    justifyContent: "space-between", // Horizontally center the icon
  }}
>
  <FontAwesomeIcon icon={faArrowDown} style={{ fontSize: "16px", justifyContent: "space-between" }} />
  {isFetchingAllNotams
    ? "Show Worldwide NOTAM's"
    : "Show Indian NOTAM's"} {/* Toggle text */}
</button>


    </LocalizationProvider>
  </div>
</div>

          {/* Search Button (Moved to the End) */}


          <div className="left-section">
            <div className="social-notam-container">
              {isLoading ? (
                <p>Loading...</p>
              ) : filteredTwitterPosts.length > 0 ? (
                filteredTwitterPosts.map((post) => (
                  <div
                    className="left-right"
                    key={post.id}
                    id={`post-${post.id}`}
                  >
                    <div className="left-container black-bg">
                      <div className="notam-text">
                        <span className="notam-title">Twitter Post</span>
                        <br />
                        <span className="notam-date">
                          {new Date(post.created_time).toLocaleDateString()}
                        </span>
                        <br />
                        <span className="notam-time">
                          {new Date(post.created_time).toLocaleTimeString()}
                        </span>
                      </div>
                      <div className="icon-container">
                        <img
                          src={`${process.env.PUBLIC_URL}/icons/twitter.png`}
                          alt="Twitter"
                        />
                      </div>
                    </div>
                    <div className="right-container">
                      <div className="notam-description-wrapper">
                        <div className="notam-description-card">
                          <div className="notam-profile-info">
                            <img
                              src={post.profile_image_url ? post.profile_image_url : process.env.PUBLIC_URL + "/icons/profiling2.png"}
                              alt="Profile"
                              className="profile-picture"
                              onClick={() => openUserProfile("twitter", post.author_username)}
                              style={{ cursor: "pointer" }}
                            />
                            <span className="username">@{post.author_username}</span>
                          </div>
                          <div className="notam-description">
                            {renderDescription(post.text, post.id, "twitter")}

                          </div>
                        </div>
                        {post.attached_medias_url && post.attached_medias_url.length > 0 && (
                          <div className="image-container">
                            {post.attached_medias_url.map((media, index) => (
                              <img
                                key={index}
                                src={media}
                                alt={`Media ${index + 1}`}
                                className="grid-image"
                                onClick={() => handleNotamImageClick(media)} // Open modal on image click
                              />
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="icons-right">
                      <div
                        className="copy-image"
                        title="Copy Screenshot"
                        onClick={() => copyScreenshotToClipboard(post.id)}
                      >
                        <FontAwesomeIcon icon={faImages} />
                      </div>
                      <div
                        className="copy-text"
                        title="Copy Text"
                        onClick={() => copyTextToClipboard(post.text)}
                      >
                        <FontAwesomeIcon icon={faCopy} />
                      </div>
                      <div
                        className="open-link"
                        title="Open Link"
                        onClick={() =>
                          openXPostLink(post.id, post.author_username)
                        }
                      >
                        <FontAwesomeIcon icon={faUpRightFromSquare} />
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <p>No Twitter posts available</p>
              )}
            </div>
          </div>
        </div>

        {/* Right Section (Facebook) */}
        <div className={`right-section-main ${isRightSectionCollapsed ? "collapsed" : ""}`}>
          <button onClick={toggleRightSection} className="collapse-btn">
            <FontAwesomeIcon icon={isRightSectionCollapsed ? faArrowLeft : faArrowRight} />
            {isRightSectionCollapsed ? " Expand" : " Collapse"}
          </button>
          {!isRightSectionCollapsed && (
  <h2 className="facebook-fixed-header">
    <img
      src={`${process.env.PUBLIC_URL}/icons/facebook.png`}
      alt="Facebook Icon"
      className="facebook-icon"
    />
    Facebook NOTAM's
  </h2>
)}



          <div className="facebook-post-header-search">
            {/* Search Input */}
            <input
              type="text"
              placeholder="Search Facebook NOTAM's"
              className="search-bar"
              value={facebookSearchTerm}
              onChange={handleFacebookSearch}
            />
            {facebookSearchTerm && (
              <button className="clear-button" onClick={clearFacebookSearch}>
                <FontAwesomeIcon icon={faTimes} />
              </button>
            )}

            {/* Date Filters (Placed before Search Button) */}
            <div className="date-filters">
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span style={{ marginRight: "10px", fontWeight: "bold" }}>
                    From
                  </span>
                  <DatePicker
                    value={facebookStartDate}
                    onChange={(newValue) => {
                      setFacebookStartDate(newValue);
                      filterFacebookPostsByDate(); // ✅ Call function when user selects date
                    }}
                    renderInput={(params) => (
                      <TextField {...params} size="small" />
                    )}
                  />
                </div>

                <div style={{ display: "flex", alignItems: "center" }}>
                  <span style={{ marginRight: "10px", fontWeight: "bold" }}>
                    TO
                  </span>
                  <DatePicker
                    value={facebookEndDate}
                    onChange={(newValue) => {
                      setFacebookEndDate(newValue);
                      filterFacebookPostsByDate(); // ✅ Call function when user selects date
                    }}
                    renderInput={(params) => (
                      <TextField {...params} size="small" />
                    )}
                  />
                </div>
                <button className="search-button">
                  <FontAwesomeIcon icon={faSearch} />
                </button>
                <button
                  onClick={() =>
                    handlefbSubmit(
                      "api/fb-notam/"
                    )
                  }
                  style={{
                    background: isapifLoading ? "#ccc" : "#007BFF", // Change button color while loading
                    color: "#fff", // Text color
                    border: "none",
                    borderRadius: "5px",
                    padding: "6px 12px",
                    cursor: isapifLoading ? "not-allowed" : "pointer", // Disable button when loading
                    display: "flex", // To align the icon properly
                    alignItems: "center", // Vertically center the icon
                    justifyContent: "center", // Horizontally center the icon
                  }}
                  disabled={isapifLoading} // Disable button while loading
                >
                  {isapifLoading ? (
                    <div className="loader-small" style={{ borderTopColor: "#fff" }} /> // Loader
                  ) : (
                    <FontAwesomeIcon icon={faSyncAlt} style={{ fontSize: "16px" }} /> // Refresh icon
                  )}
                </button>
              </LocalizationProvider>
            </div>


          </div>
          {/* Search Button (Moved to the End) */}


          <div className="left-section">
            <div className="social-notam-container">
              {isLoading ? (
                <p>Loading...</p>
              ) : filteredFacebookPosts.length > 0 ? (
                filteredFacebookPosts.map((post) => (
                  <div
                    className="left-right"
                    key={post.id}
                    id={`post-${post.id}`}
                  >
                    <div className="left-container blue-bg">
                      <div className="notam-text">
                        <span className="notam-title">Facebook Post</span>
                        <br />
                        <span className="notam-date">
                          {new Date(post.created_time).toLocaleDateString()}
                        </span>
                        <br />
                        <span className="notam-time">
                          {new Date(post.created_time).toLocaleTimeString()}
                        </span>
                      </div>
                      <div className="icon-container">
                        <img
                          src={`${process.env.PUBLIC_URL}/icons/facebook.png`}
                          alt="Facebook"
                        />
                      </div>
                    </div>
                    <div className="right-container">
                      <div className="notam-description-wrapper">
                        <div className="notam-description-card">
                          <div className="notam-profile-info">
                            <img
                              src={post.profile_image_url ? post.profile_image_url : process.env.PUBLIC_URL + "/icons/profiling2.png"}
                              alt="Profile"
                              className="profile-picture"
                              onClick={() => openUserProfile("facebook", post.owner_id)}
                              style={{ cursor: "pointer" }}
                            />
                            <span className="username">@{post.owner_username}</span>
                          </div>
                          <div className="notam-description">
                            {renderDescription(post.text, post.id, "facebook")}

                          </div>
                        </div>
                        {post.attached_image_url && (
                          <div className="image-container">
                            {Array.isArray(post.attached_image_url) ? (
                              post.attached_image_url.map((media, index) => (
                                <img
                                  key={index}
                                  src={media}
                                  alt={`Media ${index + 1}`}
                                  className="grid-image"
                                  onClick={() => handleNotamImageClick(media)} // Open modal on image click
                                />
                              ))
                            ) : (
                              <img
                                src={post.attached_image_url}
                                alt="Media"
                                className="grid-image"
                                onClick={() => handleNotamImageClick(post.attached_image_url)} // Open modal on image click
                              />
                            )}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="icons-right">
                      <div
                        className="copy-image"
                        title="Copy Screenshot"
                        onClick={() => copyScreenshotToClipboard(post.id)}
                      >
                        <FontAwesomeIcon icon={faImages} />
                      </div>
                      <div
                        className="copy-text"
                        title="Copy Text"
                        onClick={() => copyTextToClipboard(post.text)}
                      >
                        <FontAwesomeIcon icon={faCopy} />
                      </div>
                      <div
                        className="open-link"
                        title="Open Link"
                        onClick={() => openFBPostLink(post.id)}
                      >
                        <FontAwesomeIcon icon={faUpRightFromSquare} />
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <p>No Facebook posts available</p>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* Image Modal */}
      <NotamModal
        isOpen={isNotamModalOpen}
        imageUrl={selectedNotamImage}
        onClose={() => setIsNotamModalOpen(false)} // Close modal when clicking outside or using close button
      />
    </div>
  );
}

export default NotamGrid;

